// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4462":"37bd0c742dddc3c4","6396":"09997daad17c6fe4"}[chunkId] + ".css";
};